<template lang="pug">
  div.license-type
    app-select(
      :items="LICENSE_TYPES"
      label="License type"
      item-value='slug'
      item-text='name'
      :clearable="true"
      :multiple="true"
      :show-close-menu-btn="false"
      :show-clear-btn="false"
      :value="value"
      @change="updateValue($event)"
      @clear="updateValue()"
    )
</template>

<script>
import AppSelect from "@/components/global/fields/appSelect.vue";
import {LICENSE_TYPES} from "@/util/const";

export default {
  components: {AppSelect},

  props: {
    disabled: Boolean
  },

  data() {
    return {
      LICENSE_TYPES,
      licenseType: null
    }
  },

  computed: {
    value() {
      return (
        Array.isArray(this.$route.query.license_type) ?
          this.$route.query.license_type :
          [this.$route.query.license_type]
      ).map(e => {
        return LICENSE_TYPES.find(item => item.slug === e)
      });
    }
  },

  methods: {
    updateValue(value) {
      const queryUpdated = {
        ...this.$route.query,
        page: 1,
        license_type: value || undefined
      };
      // delete queryUpdated.course_id;
      // delete queryUpdated.page_name;
      // delete queryUpdated.size;
      this.$router.replace({query: queryUpdated})
      this.$emit('changed')
    },
  }
}
</script>

<style lang="scss" scoped>
.license-type {
  margin-left: 8px;
  margin-top: 8px;
  flex-shrink: 0;
}
</style>